import { configureStore } from '@reduxjs/toolkit';
import authReducer from './slices/authSlice';
import dashboardReducer from './slices/dashboardSlice';
import leadReducer from './slices/leadSlice';
import opportunityReducer from './slices/opportunitySlice';
import customerReducer from './slices/customerSlice';
import quotationReducer from './slices/quotationSlice';
import salesOrderReducer from './slices/salesOrderSlice';
import salesAnalyticsReducer from './slices/salesAnalyticsSlice';
import searchReducer from './slices/searchSlice';
import tasksReducer from './slices/tasksSlice';
import projectsReducer from './slices/projectsSlice';
import websocketReducer from './slices/websocketSlice';
import timesheetReducer from './slices/timesheetSlice';
// E-Commerce reducers
import ecommerceProductReducer from './slices/ecommerceProductSlice';
import ecommerceCartReducer from './slices/ecommerceCartSlice';
import ecommerceOrderReducer from './slices/ecommerceOrderSlice';
import ecommerceCustomerReducer from './slices/ecommerceCustomerSlice';
import ecommerceWishlistReducer from './slices/ecommerceWishlistSlice';
import ecommerceReviewReducer from './slices/ecommerceReviewSlice';
import ecommerceRecentlyViewedReducer from './slices/ecommerceRecentlyViewedSlice';
import ecommerceComparisonReducer from './slices/ecommerceComparisonSlice';
import textileCostingReducer from './slices/textileCostingSlice';
import workflowApprovalReducer from './slices/workflowApprovalSlice';
import workflowReducer from './slices/workflowSlice';
import journalEntryReducer from './slices/journalEntrySlice';
import supportTicketReducer from './slices/supportTicketSlice';
import knowledgeBaseReducer from './slices/knowledgeBaseSlice';
import faqReducer from './slices/faqSlice';
import posReducer from './slices/posSlice';
// Plant Maintenance
import pmReducer from './slices/pmSlice';
// Environment, Health & Safety
import ehsReducer from './slices/ehsSlice';
// Real Estate Management
import remReducer from './slices/remSlice';
// HRM Payroll
import hrmPayrollReducer from './slices/hrmPayrollSlice';

const store = configureStore({
  reducer: {
    auth: authReducer,
    dashboard: dashboardReducer,
    leads: leadReducer,
    opportunities: opportunityReducer,
    customers: customerReducer,
    quotations: quotationReducer,
    salesOrders: salesOrderReducer,
    salesAnalytics: salesAnalyticsReducer,
    search: searchReducer,
    tasks: tasksReducer,
    projects: projectsReducer,
    websocket: websocketReducer,
    timesheet: timesheetReducer,
    // E-Commerce
    ecommerceProducts: ecommerceProductReducer,
    ecommerceCart: ecommerceCartReducer,
    ecommerceOrders: ecommerceOrderReducer,
    ecommerceCustomer: ecommerceCustomerReducer,
    ecommerceWishlist: ecommerceWishlistReducer,
    ecommerceReviews: ecommerceReviewReducer,
    ecommerceRecentlyViewed: ecommerceRecentlyViewedReducer,
    ecommerceComparison: ecommerceComparisonReducer,
    // Textile Costing
    textileCosting: textileCostingReducer,
    // Workflow Management
    workflow: workflowReducer,
    // Workflow Approvals
    workflowApproval: workflowApprovalReducer,
    // Finance - Journal Entries
    journalEntries: journalEntryReducer,
    // Support Desk
    supportTickets: supportTicketReducer,
    knowledgeBase: knowledgeBaseReducer,
    faqs: faqReducer,
    // Point of Sale
    pos: posReducer,
    // Plant Maintenance
    pm: pmReducer,
    // Environment, Health & Safety
    ehs: ehsReducer,
    // Real Estate Management
    rem: remReducer,
    // HRM Payroll
    hrmPayroll: hrmPayrollReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['websocket/setWsInstance'],
        ignoredPaths: ['websocket.wsInstance'],
      },
    }),
});

export default store;
